import * as React from 'react'
import WidgetTagUnit from './tag-unit/tag-unit.component'

export type WidgetTagsProps = {
  tags?: GatsbyTypes.Maybe<readonly GatsbyTypes.Maybe<GatsbyTypes.keyValueFragment>[]>
}

const WidgetTags: React.FC<WidgetTagsProps> = ({ tags }) => (
  <div>
    {(tags || [])
      ?.filter(u => u?.type === 'Tag')
      ?.map(u => (
        <WidgetTagUnit key={u?.id} tag={u} />
      ))}
  </div>
)

export default WidgetTags
